var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2424,
    height: 2500,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2083.04v9.04c0 221.7 178.704 400.4 400.396 400.4 221.682 0 400.395-178.7 400.395-400.4v-441.11L0 2083.03v.01Zm2420.9 2.26c-6.78-85.96-42.97-165.13-104.06-226.2v-2.28l-719.34-635.64-699.001 375.51 902.591 803.04c67.86 58.82 153.82 90.49 244.3 90.49 11.32 0 22.63 0 31.68-2.26 99.53-9.05 190.01-56.55 253.35-131.21 67.86-74.65 97.27-171.92 90.48-271.45ZM800.791 456.576v-52.031c0-221.673-180.967-400.386-400.395-400.386C178.704 4.159 0 182.862 0 404.535v490.889l800.791-438.858v.01ZM0 1067.35 1870.77 47.137c54.29-29.41 115.37-42.988 176.45-42.988 38.45 0 76.9 6.79 115.37 18.104 196.8 63.346 303.12 273.714 239.77 470.522-27.13 81.431-79.16 151.556-151.55 199.061v2.273l-22.63 13.568L0 1911.11v-843.76Z",
    fill: "#252B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/kotlin.d3835c3e712598d34623f308eef42259.svg";
export { ForwardRef as ReactComponent };